import { UserType } from '@sit/openapi';
import { formatIntacctEntityName } from '@web/helpers/entity';

export const prepareCompaniesQuery = (companies: UserType['companies']) => {
  const query: Record<string, string> = { TOP_LEVEL: 'Top level' };

  for (const { name, intacctEntityId } of companies || []) {
    if (intacctEntityId) {
      query[intacctEntityId] = formatIntacctEntityName({
        name: name ?? '',
        intacctEntityId,
      });
    }
  }

  return query;
};
